import { CabinBlockIconSvgPPP } from "../../svgImages";
import "./style.scss";

interface ICabinBlockModal {}

const CabinBlockModal: React.FC<ICabinBlockModal> = () => {
  return (
    <div className="cabin-blocked-modal-body-wrapper">
      <CabinBlockIconSvgPPP/>  
      <h5>
        UNFORTUNATELY, THE CABIN YOU'VE <br /> SELECTED HAS BEEN BLOCKED OR SOLD OUT
      </h5>
      <span>
        Please call our travel expert at <a href="tel: 022-68811111">022-68811111</a> for further assistance.
      </span>
      <a href="tel: 022-68811111">Continue</a>
    </div>
  );
};

export default CabinBlockModal;
